module.exports = __webpack_public_path__ + "a344ea2cccff0935da3d950660e55671.png";